import { render, staticRenderFns } from "./AuthorizationSelect.vue?vue&type=template&id=7521a24e&scoped=true"
import script from "./AuthorizationSelect.vue?vue&type=script&lang=js"
export * from "./AuthorizationSelect.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationSelect.vue?vue&type=style&index=0&id=7521a24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521a24e",
  null
  
)

export default component.exports